export default __webpack_public_path__ + "static/AppStore_NoAudio-88734f20f8be8f9377396290bb03f380.mp4";